export default "__VITE_ASSET__HgPwoVnr__"